/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener('DOMContentLoaded', function () {
  var input = document.getElementById('input-text');

  var previews = [
    document.getElementById('preview21'),
    document.getElementById('preview22'),
    document.getElementById('preview23'),
    document.getElementById('preview24'),
    document.getElementById('preview25'),
    document.getElementById('preview26'),
    document.getElementById('preview27'),
    document.getElementById('preview28')
  ];

  if (!input) return;

  function updateFontPreview() {
    var text = input.value.trim() || 'aaa';

    previews.forEach(function (preview) {
      if (preview) {
        preview.textContent = text;
      }
    });
  }

  input.addEventListener('input', updateFontPreview);
  updateFontPreview();
});

document.addEventListener('DOMContentLoaded', function () {
  var line1Input = document.querySelector(
    'input[name="properties[Engraving - Line 1]"]'
  );

  var line2Input = document.querySelector(
    'input[name="properties[Engraving - Line 2]"]'
  );

  var layoutInputs = document.querySelectorAll(
    'input[name="properties[Text Layout]"]'
  );

  var previews = [
    document.getElementById('rod-preview11'),
    document.getElementById('rod-preview12'),
    document.getElementById('rod-preview13'),
    document.getElementById('rod-preview14'),
    document.getElementById('rod-preview15'),
    document.getElementById('rod-preview16'),
    document.getElementById('rod-preview17'),
    document.getElementById('rod-preview18')
  ];

  if (!line1Input || !previews.some(function (preview) { return preview; })) {
    return;
  }

  function updateRodFontPreview() {
    var line1 = line1Input.value.trim() || 'aaa';

    var selectedLayout = document.querySelector(
      'input[name="properties[Text Layout]"]:checked'
    );

    var isTwoLines = selectedLayout && selectedLayout.value === 'Two lines';
    var line2 = line2Input ? line2Input.value.trim() : '';

    var previewText = line1;

    if (isTwoLines && line2) {
      previewText += '\n' + line2;
    }

    previews.forEach(function (preview) {
      if (preview) {
        preview.textContent = previewText;
      }
    });
  }

  line1Input.addEventListener('input', updateRodFontPreview);

  if (line2Input) {
    line2Input.addEventListener('input', updateRodFontPreview);
  }

  layoutInputs.forEach(function (input) {
    input.addEventListener('change', updateRodFontPreview);
  });

  updateRodFontPreview();
});

(function () {
  function initRodLivePreviews() {
    document.querySelectorAll('[data-semi-custom-rod]').forEach(function (root) {
      var productId = root.getAttribute('data-semi-custom-rod');

      var line1Input = document.getElementById(
        'semi-custom-rod-line-1-' + productId
      );

      var line2Input = document.getElementById(
        'semi-custom-rod-line-2-' + productId
      );

      var line1Font = document.getElementById(
        'semi-custom-rod-font-line-1-' + productId
      );

      var line2Font = document.getElementById(
        'semi-custom-rod-font-line-2-' + productId
      );

      var previewLine1 = document.getElementById(
        'semi-custom-rod-preview-line-1-' + productId
      );

      var previewLine2 = document.getElementById(
        'semi-custom-rod-preview-line-2-' + productId
      );

      var layoutInputs = root.querySelectorAll(
        'input[name="properties[Text Layout]"]'
      );

      if (
        !line1Input ||
        !line1Font ||
        !previewLine1 ||
        !previewLine2 ||
        !layoutInputs.length
      ) {
        return;
      }

      function updateRodPreview() {
        var selectedLayout = root.querySelector(
          'input[name="properties[Text Layout]"]:checked'
        );

        var isTwoLines =
          selectedLayout && selectedLayout.value === 'Two lines';

        previewLine1.textContent = line1Input.value || 'Your text';
        previewLine1.dataset.font = line1Font.value || '';

        previewLine2.hidden = !isTwoLines;

        if (isTwoLines) {
          previewLine2.textContent =
            line2Input && line2Input.value ? line2Input.value : 'Second line';

          previewLine2.dataset.font =
            line2Font && line2Font.value ? line2Font.value : '';
        }
      }

      line1Input.addEventListener('input', updateRodPreview);
      line1Font.addEventListener('change', updateRodPreview);

      if (line2Input) {
        line2Input.addEventListener('input', updateRodPreview);
      }

      if (line2Font) {
        line2Font.addEventListener('change', updateRodPreview);
      }

      layoutInputs.forEach(function (input) {
        input.addEventListener('change', updateRodPreview);
      });

      updateRodPreview();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRodLivePreviews);
  } else {
    initRodLivePreviews();
  }
})();

(function () {
  function init12thLivePreviews() {
    document.querySelectorAll('[data-semi-custom-12th]').forEach(function (root) {
      var productId = root.getAttribute('data-semi-custom-12th');

      var textInput = document.getElementById(
        'semi-custom-text-' + productId
      );

      var fontSelect = document.getElementById(
        'semi-custom-font-style-' + productId
      );

      var preview = document.getElementById(
        'semi-custom-12th-preview-text-' + productId
      );

      if (!textInput || !fontSelect || !preview) {
        return;
      }

      function update12thPreview() {
        preview.textContent = textInput.value || 'Your text';
        preview.dataset.font = fontSelect.value || '';
      }

      textInput.addEventListener('input', update12thPreview);
      fontSelect.addEventListener('change', update12thPreview);

      update12thPreview();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init12thLivePreviews);
  } else {
    init12thLivePreviews();
  }
})();